import { render, staticRenderFns } from "./returnOrderDetail.vue?vue&type=template&id=0fce5e16&scoped=true&"
import script from "./returnOrderDetail.vue?vue&type=script&lang=js&"
export * from "./returnOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./returnOrderDetail.vue?vue&type=style&index=0&id=0fce5e16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce5e16",
  null
  
)

export default component.exports